import useTableColumnBuilder from "hooks/useTableColumnBuilder";
import { IDistributionOrder } from "domain/Inventory/Models/IDistributionOrder";
import { SBTranslate } from "i18n";
import { SBBox, SBIcon } from "modules/Commons";

export const useDistributionOrderHeaders = () => {
	const { add, build, integerFormatter, dateFormatter } =
		useTableColumnBuilder<IDistributionOrder>();

	add({
		id: () => "inventory",
		name: " ",
		hideToggle: true,
		headers: [
			{
				id: (c) => (
					<SBBox style={{ cursor: "pointer" }}>
						<SBIcon icon="inventory" hoverFillColor="primary" />
					</SBBox>
				),
				csvName: SBTranslate("inventory"),
				align: "center",
				csvHide: true,
				width: 1,
				key: "inventory",
				name: "",
				fixed: true,
			},
		],
	});

	add({
		id: () => "order",
		name: "order",
		headers: [
			{
				id: (c) => c.guid ?? "",
				key: "guid",
				name: SBTranslate("code"),
				csvName: SBTranslate("distributionOrderCSVNames.guid"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.documentNumber ?? "---",
				key: "documentNumber",
				name: SBTranslate("documentNumber"),
				csvName: SBTranslate("distributionOrderCSVNames.documentNumber"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "product",
		name: "product",
		headers: [
			{
				id: (c) => c.productClientID ?? "",
				key: "productClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("distributionOrderCSVNames.productClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.productName ?? "",
				key: "productName",
				name: SBTranslate("product"),
				csvName: SBTranslate("distributionOrderCSVNames.productName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "store",
		name: "store",
		headers: [
			{
				id: (c) => c.destinationStoreClientID ?? "",
				key: "storeClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("distributionOrderCSVNames.storeClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.destinationStoreName ?? "",
				key: "storeName",
				name: SBTranslate("store"),
				csvName: SBTranslate("distributionOrderCSVNames.storeName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "sourceStore",
		name: "sourceStore",
		headers: [
			{
				id: (c) => c.sourceStoreClientID ?? "",
				key: "sourceStoreClientID",
				name: SBTranslate("code"),
				csvName: SBTranslate("distributionOrderCSVNames.sourceStoreClientID"),
				align: "left",
				noWrap: true,
			},
			{
				id: (c) => c.sourceStoreName ?? "",
				key: "sourceStoreName",
				name: SBTranslate("sourceStore"),
				csvName: SBTranslate("distributionOrderCSVNames.sourceStoreName"),
				align: "left",
				noWrap: true,
			},
		],
	});

	add({
		id: () => "dates",
		name: "dates",
		headers: [
			{
				id: (c) => c.created ?? "",
				key: "created",
				name: SBTranslate("created"),
				csvName: SBTranslate("distributionOrderCSVNames.created"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.created ?? ""),
			},
			{
				id: (c) => c.ordered ?? "",
				key: "ordered",
				name: SBTranslate("ordered"),
				csvName: SBTranslate("distributionOrderCSVNames.ordered"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.ordered ?? ""),
			},
			{
				id: (c) => c.expected ?? "",
				key: "expected",
				name: SBTranslate("expected"),
				csvName: SBTranslate("distributionOrderCSVNames.expected"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.expected ?? ""),
			},
			{
				id: (c) => c.integrated ?? "",
				key: "integrated",
				name: SBTranslate("integrated"),
				csvName: SBTranslate("distributionOrderCSVNames.integrated"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.integrated ?? ""),
			},
			{
				id: (c) => c.received ?? "",
				key: "received",
				name: SBTranslate("received"),
				csvName: SBTranslate("distributionOrderCSVNames.received"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.received ?? ""),
			},
			{
				id: (c) => c.closed ?? "",
				key: "closed",
				name: SBTranslate("closed"),
				csvName: SBTranslate("distributionOrderCSVNames.closed"),
				align: "left",
				noWrap: true,
				formatter: dateFormatter,
				csvValue: (c) => dateFormatter(c.closed ?? ""),
			},
		],
	});

	add({
		id: () => "values",
		name: "values",
		headers: [
			{
				id: (c) => c.quantity,
				key: "quantity",
				name: SBTranslate("quantity"),
				csvName: SBTranslate("distributionOrderCSVNames.quantity"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.receivedQuantity,
				key: "receivedQuantity",
				name: SBTranslate("receivedQuantity"),
				csvName: SBTranslate("distributionOrderCSVNames.receivedQuantity"),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
			{
				id: (c) => c.supplyBrainRecommendation,
				key: "supplyBrainRecommendation",
				name: SBTranslate("supplyBrainRecommendation"),
				csvName: SBTranslate(
					"distributionOrderCSVNames.supplyBrainRecommendation",
				),
				align: "right",
				noWrap: true,
				formatter: integerFormatter,
			},
		],
	});

	return { headers: build() };
};
